<template>
  <notificationGroup group="bottom" position="bottom">
    <div class="inset-0 flex px-4 py-6 pointer-events-none p-6 items-start justify-end" style="pointer-events:none;">
      <div class="w-100" style="pointer-events:auto;">
        <notification v-slot="{ notifications, close }">
        <!-- <div class="d-flex max-w-sm w-100 mx-auto bg-white shadow-md rounded-lg overflow-hidden mt-4"> -->
          <div
            class="notification-container rounded-lg max-w-sm w-full mx-auto shadow-md overflow-hidden"
            v-for="notification in notifications"
            :key="notification.id" @click="close(notification.id)">
            <button class="btn-close">
              <svg width="14" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9663 11.1996L8.43334 6.66667L12.9663 2.13371C13.4557 1.64432 13.4557 0.856436 12.9663 0.367044C12.4769 -0.122348 11.689 -0.122348 11.1996 0.367044L6.66667 4.9L2.13371 0.367044C1.64432 -0.122348 0.856436 -0.122348 0.367044 0.367044C-0.122348 0.856436 -0.122348 1.64432 0.367044 2.13371L4.9 6.66667L0.367044 11.1996C-0.122348 11.689 -0.122348 12.4769 0.367044 12.9663C0.856436 13.4557 1.64432 13.4557 2.13371 12.9663L6.66667 8.43334L11.1996 12.9663C11.689 13.4557 12.4769 13.4557 12.9663 12.9663C13.4522 12.4769 13.4522 11.6855 12.9663 11.1996Z" fill="white"/>
              </svg>
            </button>

            <div class="d-flex mx-5 justify-content-center">
              <span class="text-sm">{{ notification.text }}</span>
            </div>
          </div>
        </notification>
      </div>
    </div>
  </notificationGroup>
</template>

<script>

export default {
  name: 'Notifications',
  props: {
    eventName: {
      type: String,
      default: 'mr-notif'
    },
    noReset: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      notification: {
        id: 'notif-0',
        title: 'Success',
        text: 'Description'
      }
    }
  },
  created () {
    if (!this.noReset) {
      this.$bus.$off(this.eventName)
    }
    this.$bus.$on(this.eventName, data => {
      this.$notify({
        group: 'bottom',
        text: data.text
      }, 8000)
    })
  }
}
</script>

<style>
/* tailwind css */
.shadow-md {
  box-shadow: var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow);
}
.rounded-lg	{
  border-radius: 35px;
}
.fill-current	{
  fill: currentColor;
}
.bg-green-500 {
  background-color: rgba(6.3%, 72.5%, 50.6%, 1);
}
.bg-red-500 {
  background-color: rgba(93.7%, 26.6%, 26.6%, 1);
}
.h-6 {
  height: 1.5rem;
}
.w-6 {
  width: 1.5rem;
}
.w-12	{
  width: 3rem;
}
.max-w-sm {
  max-width: 345px;
  min-height: 50px;
}
.mt-4	{
  margin-top: 1rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.px-4	{
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-6	{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.p-6 {
  padding: 1.5rem;
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: white;
}
.font-semibold {
  font-weight: 600;
}
.text-sm {
  font-family: Ubuntu;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
}
.notif-group-container {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 6rem;
  padding-bottom: 1.5rem;
}
.notification-container {
  display: flex;
  position: relative;
  justify-content: center;
  background-color: #49a0a2;
  margin-top: 4%;
}
.btn-close {
  position:absolute;
  top: 1%;
  left: 1%;
  background-color: #49a0a2;
  border: none;
  font-weight: semibold;
  color: white;
  font-size: 15px;
  margin-left: 2px;
  margin-top: 2px;
}

</style>



// WEBPACK FOOTER //
// notifications.vue?64507b7c